import { createSlice } from "@reduxjs/toolkit";
import {
    clearPersistedTasksListState,
    getPersistedTasksListState,
    setPersistedTasksListState,
} from "../lib/tasksFilters";

const persisted = getPersistedTasksListState()

const initialHistoryState = {
    currentpage: persisted?.currentpage ?? 1,
    currentpagedata: null,
    listFiltersParams: null,
    filters: persisted?.filters ?? {},
    pageResults: null,
    isAPracticeUsedAsFilter: null,
    snapshotData: null,
    snapshotDataVerification: null,
    orderFilters: persisted?.orderFilters ?? null,
    loading: false,
    dashboardList: null,
    refreshApi: 0,
    requesterId: null,
}

function persistListState(state) {
    setPersistedTasksListState({
        filters: state.filters,
        currentpage: state.currentpage,
        orderFilters: state.orderFilters,
    })
}

const tasksSlice = createSlice({
    name: 'tasks',
    initialState: initialHistoryState,
    reducers: { 
        setCurrentPage(state, data) {
            state.currentpage = data.payload
            persistListState(state)
        },
        setCurrentPageData(state, data) {
            state.currentpagedata = data.payload
        },
        saveListFiltersParams(state, data) {
            state.listFiltersParams = data.payload
        },
        setFilters(state, data) {
            state.filters[data.payload.filter] = data.payload.value
            persistListState(state)
        },
        setFiltersMultiple(state, data) {
            state.filters = data.payload
            persistListState(state)
        },
        removeSingleFilter(state, data) {
            if (!data.payload.multiple) { // if its not for a multiple selection, simply remove
                state.filters[data.payload.filter] = null
            } else { // multiple selection!!!
                const itemIndex = state.filters[data.payload.filter].findIndex(object => {
                    return object.value == data.payload.value                  
                })

                if (itemIndex !== -1) {
                    if (state.filters[data.payload.filter].length == 1) {
                        state.filters[data.payload.filter] = null
                    } else {
                        state.filters[data.payload.filter].splice(itemIndex, 1)
                    }      
                    
                }
            }
            persistListState(state)
        },
        clearFilters(state) {
            state.filters = {}
            persistListState(state)
        },
        resetPersistedListState(state) {
            state.filters = {}
            state.currentpage = 1
            state.orderFilters = null
            state.currentpagedata = null
            state.snapshotData = null
            clearPersistedTasksListState()
        },
        setPageResults(state, data) {
            state.pageResults = data.payload
        },
        setIsAPracticeUsedAsFilter(state, data) {
            state.isAPracticeUsedAsFilter = data.payload
        },
        setSnapshotData(state, data) {
            state.snapshotData = data.payload
        },
        setSnapshotDataVerification(state, data) {
            state.snapshotDataVerification = data.payload
        },
        setSnapshotDataGeneral(state, data) {
            state.snapshotDataGeneral = data.payload
        },
        setOrderFilters(state, data) {
            state.orderFilters = data.payload
            persistListState(state)
        },
        setMasterLoading(state, data) {
            state.loading = data.payload
        },
        setRefreshApi(state) {
            state.refreshApi = state.refreshApi + 1
        },
        setDashboardList(state, data) {
            state.dashboardList = data.payload
        },
        setRequesterId(state, data) {
            state.requesterId = data.payload
        },
        removeTasksByIds(state, data) {
            const ids = new Set((data.payload || []).map((id) => String(id)))
            if (ids.size === 0) {
                return
            }
            const withoutIds = (list) => {
                if (!list) {
                    return list
                }
                if (Array.isArray(list)) {
                    return list.filter((item) => !ids.has(String(item?.id)))
                }
                if (Array.isArray(list.data)) {
                    return {
                        ...list,
                        data: list.data.filter((item) => !ids.has(String(item?.id))),
                    }
                }
                return list
            }
            state.currentpagedata = withoutIds(state.currentpagedata)
            state.snapshotData = withoutIds(state.snapshotData)
            state.dashboardList = withoutIds(state.dashboardList)
        }
    }
})

export const tasksActions = tasksSlice.actions

export default tasksSlice.reducer
